import { apiSlice } from '../../apiSlice';

export const jobSpecificationApiSlice = apiSlice.injectEndpoints({
    tagTypes: ["JobSpecifications"],
    endpoints: builder => ({
        getJobSpecifications: builder.query({
            query: () => `/JobSpecification`,
            providesTags: ["JobSpecifications"],
            keepUnusedDataFor: 60, //This is the caching mechanism keeps the data for 5 seconds - default is 60
        }),
    }),
})

export const {
    useGetJobSpecificationsQuery
} = jobSpecificationApiSlice